import React, { useEffect, useState } from "react";
import SatLogo from "../../assets/Images/SATprep1.svg";
import AuthButton from "../LogInPage/LoginButton";
import { IoIosPlay } from "react-icons/io";
import { useGetEnabledTestTypesQuery, useGetRemainingTestCountQuery, useLazyRetrieveTestQuery, useResumeTestQuery } from "../../redux/API/StartTest/startTestApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { openDialog, setIsTestCompletedDialogClosed } from "../../redux/Slices/dialogSlice";
import { changeCurrentModuleName, setCount, setCurrentTime, setExtendedBreaks, setExtraBreaks, setHasHighlightPopupBeenShown, setHighlightedContent, setIsModuleCompleted, setIsPopUp, setIsResumeTest, setIsTestStarted, setMathModuleOneQuestions, setMathModuleTime, setMathModuleTwoQuestions, setOptionStrikerButton, setReadingModuleOneQuestions, setReadingModuleTime, setReadingModuleTwoQuestions, setRemainingTestCount, setReviewPageClicked, setSelectTestType, setStartedTestId, setStrikedOptionsData, setTestDifficulty, setTestId, setTestName, setUserTestId, StartedTestId } from "../../redux/Slices/startFullTestSlice";
import { getItem, setItem } from "../../utils/token";
import { addQuestionId } from "../../utils";
import { clearAnswers, retrieveMathsModuleOneAnswers, retrieveMathsModuleTwoAnswers, retrieveReadingModuleOneAnswers, retrieveReadingModuleTwoAnswers } from "../../redux/Slices/resultSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { BiTrash } from "react-icons/bi";

type HeaderV1Props = {
  isResumeEnabled: boolean;
  startDisable: boolean;
  handleResumeTest: () => void;
  handleStartTest: (value: boolean) => void;
  openDiscard: () => void;
};

const HeaderV1 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const {parentStudentId,startedTestId,remainingTestCount,isTestCompletedDialogClosed} = useSelector((state : RootState) => ({
      parentStudentId: state.root.startFullTest.parentStudentId,
      remainingTestCount: state.root.startFullTest.remainingTestCount,
      startedTestId: state.root.startFullTest.startedTestId,
      isTestCompletedDialogClosed: state.root.dialog.isTestCompletedDialogClosed
    }));

    const [startDisable,setStartDisable] = useState(false);

    const {data,isSuccess,isError} = useResumeTestQuery({},{refetchOnMountOrArgChange:true,skip : getItem("userRole") === "PARENT"});
    const [retrieveTest] = useLazyRetrieveTestQuery();
    const {data: testCountData,isSuccess:testCountSuccess} = useGetRemainingTestCountQuery({userId:getItem("userRole") === "PARENT" ? parentStudentId : getItem("userId")},{skip : getItem('userRole') === 'PARENT' && parentStudentId === "",refetchOnMountOrArgChange:true});
    const {data: enabledTestData, isSuccess:enabledTestDataSuccess} = useGetEnabledTestTypesQuery({},{skip: getItem("userRole") === "PARENT" && getItem("isCustomSAT") !== "",refetchOnMountOrArgChange:true});

    const isParent = getItem("userRole") === "PARENT";

    const openDiscard = () => {
      dispatch(openDialog("discardInfo"));
    }

    const resumeTest = async (item: StartedTestId) => {
        try {
            if (item.userTestId) {
            const response = await retrieveTest(item.userTestId);
            if (response.isSuccess) {
                let moduleName =
                response.data?.data?.additionalProps?.currentModuleName;
                let count = response.data?.data?.additionalProps?.count;
                localStorage.setItem("currentTestName", item.testName);
                dispatch(setTestId(item.testId));
                dispatch(setTestName(item.testName));
                let strikedAndMarkedData =
                response.data?.data?.additionalProps?.strikedAndMarkedData;
                let highlightedContent =
                response.data?.data?.additionalProps?.highlightedContent;
                let time = response.data?.data?.additionalProps?.currentTime;
                let reviewPage =
                response.data?.data?.additionalProps?.reviewPageClicked;
                dispatch(setStrikedOptionsData(strikedAndMarkedData));
                dispatch(setHighlightedContent(highlightedContent));
                dispatch(setReviewPageClicked(reviewPage));
                dispatch(setOptionStrikerButton(response.data?.data?.additionalProps?.optionStrikerButton));
                if (response.data.data) {
                    if (response?.data?.data?.isCustomTest){
                        dispatch(setSelectTestType('custom'));
                    }else{
                        dispatch(setSelectTestType('standard'));
                    } 
                    dispatch(
                        setReadingModuleTime(
                        response?.data?.data?.testDifficultyInfo?.["readingAndWriting"]
                            ?.time
                        )
                    );
                    dispatch(
                        setMathModuleTime(
                        response?.data?.data?.testDifficultyInfo?.["mathematics"]?.time
                        )
                    );

                    dispatch(
                        setTestDifficulty({
                        key:'Reading',
                            value:response?.data?.data?.testDifficultyInfo?.readingAndWriting.module1DifficultyLevel,
                        })
                    );

                    dispatch(
                        setTestDifficulty({
                        key:'Math',value: response?.data?.data?.testDifficultyInfo?.["mathematics"]
                            ?.module1DifficultyLevel,
                        })
                    );

                    if (response?.data?.data?.testDifficultyInfo?.extendedBreaks){
                        dispatch(setExtendedBreaks(true));
                    }
                    if (response?.data?.data?.testDifficultyInfo?.extraBreaks) {
                        dispatch(setExtraBreaks(true));
                    }
                    let questions = response.data.data.questionData;
                    let answersData = response.data.data.answerData;

                    let readingQuestions = questions[`ReadingAndWriting`];
                    let mathsQuestions = questions[`Mathematics`];

                    let mathAnswers = answersData[`Mathematics`];
                    let readingAnswers = answersData[`ReadingAndWriting`];
                    dispatch(setTestId(item.testId));
                    dispatch(setUserTestId(response.data.data.userTestId));

                    const readingModuleOneQuestions = addQuestionId(
                        readingQuestions[`Module1`]
                    );
                    const readingModuleTwoQuestions = addQuestionId(
                        readingQuestions[`Module2`]
                    );
                    const mathsModuleOneQuestions = addQuestionId(
                        mathsQuestions[`Module1`]
                    );
                    const mathsModuleTwoQuestions = addQuestionId(
                        mathsQuestions[`Module2`]
                    );

                    dispatch(setReadingModuleOneQuestions(readingModuleOneQuestions));
                    dispatch(setReadingModuleTwoQuestions(readingModuleTwoQuestions));
                    dispatch(setMathModuleOneQuestions(mathsModuleOneQuestions));
                    dispatch(setMathModuleTwoQuestions(mathsModuleTwoQuestions));
                    dispatch(retrieveMathsModuleOneAnswers(mathAnswers[`Module1`]));
                    dispatch(retrieveMathsModuleTwoAnswers(mathAnswers[`Module2`]));
                    dispatch(retrieveReadingModuleOneAnswers(readingAnswers[`Module1`]));
                    dispatch(retrieveReadingModuleTwoAnswers(readingAnswers[`Module2`]));
                    dispatch(changeCurrentModuleName(moduleName));
                    dispatch(setCount(count));
                    dispatch(setCurrentTime(time));
                    dispatch(setIsTestStarted(true));
                    if(location.pathname.includes("/practices/results") ){
                      navigate("/practices/results");
                    }
                    if(location.pathname.includes("/purchasehistory") || location.pathname.includes("/transactionsummary") || location.pathname.includes("/plans")){
                      navigate("/dashboard");
                    }
                }
            }
                setStartDisable(false);
            }
        } catch (e) {
            console.log(e,'error')
            setStartDisable(false);
        }
    };

    const handleResumeTest = () => {
        setStartDisable(true);
        dispatch(setHasHighlightPopupBeenShown(false));
        resumeTest(startedTestId)
        dispatch(setReviewPageClicked(false));
        dispatch(setIsModuleCompleted(false));
        dispatch(setIsPopUp(false));
        setItem("testType", "FULL");
        dispatch(setIsResumeTest(true))
    }

    const handleStartTest = () => {
      if(remainingTestCount < 1){
        dispatch(openDialog("testCompleted"));
      }else{
        dispatch(setCount(""));
        dispatch(setHasHighlightPopupBeenShown(false));
        dispatch(setSelectTestType(""));
        dispatch(setExtraBreaks(false));
        dispatch(setExtendedBreaks(false));
        dispatch(setStrikedOptionsData([]));
        dispatch(setHighlightedContent([]));
        dispatch(openDialog("customSat"));
        dispatch(setCurrentTime(1920));
        dispatch(setReadingModuleTime(1920));
        dispatch(setMathModuleTime(2100));
        setItem("testType", "FULL");
        dispatch(clearAnswers());
        dispatch(setReviewPageClicked(false));
        dispatch(setIsModuleCompleted(false));
        dispatch(setIsPopUp(false));
        dispatch(setIsResumeTest(false));
        dispatch(setTestDifficulty({ key: "Reading", value: 'MEDIUM' }));
        dispatch(setTestDifficulty({ key: "Math", value: 'MEDIUM' }));
      }
    }

    useEffect(() => {
      if(isSuccess && data){
      let payload = {
        testId : data.testId ?? [],
        testName: data.testname ?? "",
        createdDate: data.createdDate ?? "",
        userTestId : data?.userTestId ?? "",
        isFirstTest : data?.isFirstTest ?? false,
        loading: false,
      }
      dispatch(setStartedTestId(payload));
      }
      if(isError){
      let payload = {
        testId : [],
        testName: "",
        createdDate: "",
        userTestId : "",
        isFirstTest : false,
        loading : false
      }
      dispatch(setStartedTestId(payload));
      }
    },[data, isSuccess, isError, dispatch]);

    useEffect(() => {
      if(testCountSuccess && testCountData){
        dispatch(setRemainingTestCount(testCountData?.data?.testsCount ?? 0));
        if(isParent && testCountData?.data?.testsCount < 1 && !isTestCompletedDialogClosed){
          dispatch(openDialog("testCompleted"));
          dispatch(setIsTestCompletedDialogClosed(true));
        }
      }
    },[testCountData, testCountSuccess]);

    useEffect(() => {
      if(enabledTestDataSuccess && enabledTestData){
        let isCustomSAT = enabledTestData?.data?.find((item: string) => item.trim().toLowerCase().startsWith('custom'));
        if(isCustomSAT){
          setItem("isCustomSAT", "true");
        }else{
          setItem("isCustomSAT", "false");
        }
      }
    },[enabledTestData, enabledTestDataSuccess]);
  return (
  <>
    {isParent ? (
      <div className="p-3 max-h-[10vh] min-h-[98px] flex justify-center items-center self-stretch rounded-[28px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
        <img
          src={SatLogo}
          alt="Sat-Logo"
          className="w-[223px] h-[72px] mt-2"
        />
      </div>
    ) : (
      <div className="p-3 max-h-[10vh] min-h-[98px] flex justify-between items-center self-stretch rounded-[28px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
        <img src={SatLogo} alt="Sat-Logo" className="w-[223px] h-[72px] mt-2" />
        <div className="p-3 rounded-[18px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
          {startedTestId.testId.length > 0 ? (
            <div className="flex gap-6">
              <AuthButton
                text="Resume Test"
                onClick={handleResumeTest}
                disabled={startDisable}
                className="font-gully text-lg"
                icon={<IoIosPlay size={24} />}
                iconPosition="left"
              />
              <button
                onClick={openDiscard}
                className={`flex items-center justify-center py-[10px] px-[22px] rounded-md border border-satPrepRed  bg-satPrepWhite}`}
              >
                <BiTrash size={22} className="text-satPrepRed" />
              </button>
            </div>
          ) : (
            <AuthButton
              text="Start Test"
              onClick={() => handleStartTest()}
              // disabled={startDisable}
              className="font-gully text-lg"
              icon={<IoIosPlay size={24} className="mb-1" />}
              iconPosition="left"
            />
          )}
        </div>
      </div>
    )}
    </>
  );
};

export default HeaderV1;
